import styled from 'styled-components';

export const StyledRadioButton = styled.label`
  --radio-btn-clr-default: ${({ theme }) => theme.colors.radioBtnDefault};
  --radio-btn-clr-hover: ${({ theme }) => theme.colors.radioBtnHover};
  --radio-btn-clr-checked: ${({ theme }) => theme.colors.radioBtnChecked};
  --radio-btn-clr-disabled: ${({ theme }) => theme.colors.radioBtnDisabled};

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  color: var(--radio-btn-clr-default);
  font-size: 16px;
`;

export const Input = styled.input`
  //reset
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  //actual styling
  width: 24px;
  height: 24px;
  aspect-ratio: 1;
  border: 2px solid currentColor;
  border-color: var(--radio-btn-clr-default);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &::after {
    content: '';
    width: 16px;
    height: 16px;
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: var(--radio-btn-clr-default);
    transform: scale(0); //hide
    transition: 120ms transform ease-in-out;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: 2px;
  }

  .quiz & {
    border-color: ${({ theme }) => theme.colors.primaryDarkGray600};

    &::after {
      background-color: ${({ theme }) => theme.colors.primaryDarkGray600};
    }

    ~ ${Label} {
      color: ${({ theme }) => theme.colors.radioBtnQuiz};
      font-weight: 400 !important;
    }
  }

  &.checked {
    border-color: var(--radio-btn-clr-checked);

    &::after {
      transform: scale(1); //show
      background-color: var(--radio-btn-clr-checked);
    }

    ~ ${Label} {
      color: var(--radio-btn-clr-checked);
      font-weight: 600;
    }
  }

  &:hover {
    border-color: var(--radio-btn-clr-hover);

    &::after {
      background-color: var(--radio-btn-clr-hover);
    }

    ~ ${Label} {
      color: var(--radio-btn-clr-hover);
    }
  }

  &[disabled] {
    border-color: var(--radio-btn-clr-disabled);

    &::after {
      background-color: var(--radio-btn-clr-disabled);
    }

    ~ ${Label} {
      color: var(--radio-btn-clr-disabled);
      font-weight: 400 !important;
    }
  }
`;
